@if (isDefaultHeaderMode) {
  <div class="header-row">
    <div class="app-logo">
      <img src="assets/images/csadminlogo.gif" alt="csadminlogo" (click)="goToHome()">
    </div>
    <div class="bg-graphics">
      <img src="assets/images/GUIbg.gif" alt="header-bg">
    </div>
    <div>
      @if (!user.isAuthenticated) {
        <div class="inactive-lookup">
          <img src="assets/images/inactive_top.png" alt="Inactive Lookup">
        </div>
      }
      @if (user.isAuthenticated) {
        <div class="rounded-1 header-link">
          @if (hasBenefitLookupAccess()) {
            <a class="header-link-text-lookup" href="javascript:void(0);" (click)="redirectBenefitLookup()">
              {{content.labels.benefit_lookup}}
            </a> |
          }
          @if (hasMemberPaymentAccess()) {
            <a class="header-link-text member-payment" href="javascript:void(0);" (click)="memberPaymentResearchSso()">
              {{content.labels.member_payment_research}}
            </a> |
          }
          <a class="header-link-text" href="javascript:void(0);"
             [class.link-disabled]="!hasMyProfileAccess()"
             (click)="hasMyProfileAccess() && goToProfile()">
            {{content.labels.my_profile}}
          </a> |
          <a class="header-link-text" href="javascript:void(0);" (click)="logOff();">
            {{content.labels.logoff}}
          </a>
        </div>
      }
      <div class="bls-logo">
        <img src="assets/images/BLlogo.gif" alt="Blue Shield of California">
      </div>
    </div>
  </div>
} @else {
  <div class="simple-header">
    <img class="secondary-logo" src="assets/images/bsc-logosecondary.gif" alt="Bsc secondary logo">
    <button class="home-btn" (click)="goToHome()">Home</button>
  </div>
}
